export const FOOTBALL_BASE_URL = 'https://api.football-data.org/v2';
export const TOKEN_1 = 'ffd61d87e73740c29dd389ea7619d5e1';
export const TOKEN_2 = '78ef85b57ae0442b9ec98a46dfd91caf';
export const TOKEN_3 = 'e2721cef07c84dcca4fad3713170e14b';
export const TOKEN_4 = '697badcceea244758d7e3a2f010cf4da';
